import { RootState } from "../../../../store";

export const filterTemplatesEnabledSelector = (state: RootState) => {
  return state.account.filterTemplatesEnabled;
};
